import React, {useState} from "react";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

import VLFCard from "@/components/Card";
import Loading from "@/components/Loading";
import {quickQuestionsConfig} from "./quickQuestionsConfig";

import "./index.scss";

function QuickQuestions(props) {
	const {handleNotification} = props;
	const navigate = useNavigate();
	const {t} = useTranslation();

	const seasonId = useSelector((state) => state?.season?.id);
	const [loading, setLoading] = useState(false);
	const [selectedQuestion, setSelectedQuestion] = useState(null);
	const [answer, setAnswer] = useState(null);

	const handleQuestionClick = async (question) => {
		setSelectedQuestion(question);
		setAnswer(null);
		setLoading(true);

		try {
			const result = await question.getAnswer(seasonId, handleNotification);
			setAnswer(result);
		} catch (error) {
			handleNotification(
				t("error_fetching_answer") || "Errore nel recupero della risposta",
				"error",
			);
			setAnswer({
				error: true,
				message:
					t("unable_to_fetch_answer") || "Impossibile recuperare la risposta",
			});
		} finally {
			setLoading(false);
		}
	};

	const resetQuestion = () => {
		setSelectedQuestion(null);
		setAnswer(null);
	};

	const renderAnswer = () => {
		if (!answer) return null;

		if (answer.error) {
			return <div className="answer-error">{answer.message}</div>;
		}

		if (answer.type === "player") {
			return (
				<div
					className="answer-player-card"
					onClick={() => navigate(`/players/${answer.player.id}`)}
				>
					<div className="player-name">
						{answer.player.firstName} {answer.player.lastName}
					</div>
					<div className="player-info-grid">
						{answer.value !== undefined && (
							<div className="player-info-item">
								<span className="info-label">{answer.label}</span>
								<span className="info-value highlight">{answer.value}</span>
							</div>
						)}
						{answer.player.category && answer.player.category !== "N/A" && (
							<div className="player-info-item">
								<span className="info-label">
									{t("category") || "Categoria"}
								</span>
								<span className="info-value">{answer.player.category}</span>
							</div>
						)}
						{answer.player.club && answer.player.club !== "N/A" && (
							<div className="player-info-item">
								<span className="info-label">{t("team") || "Squadra"}</span>
								<span className="info-value">{answer.player.club}</span>
							</div>
						)}
						{answer.player.primaryRole &&
							answer.player.primaryRole !== "N/A" && (
								<div className="player-info-item">
									<span className="info-label">{t("role") || "Ruolo"}</span>
									<span className="info-value">
										{answer.player.primaryRole}
									</span>
								</div>
							)}
					</div>
				</div>
			);
		}

		return <div className="answer-text">{answer.text}</div>;
	};

	return (
		<div className="quick-questions-container px-1">
			<VLFCard
				title={t("quick_questions_title") || "Domande rapide"}
				className="quick-questions-card"
				content={
					<div className="quick-questions-content">
						{!selectedQuestion ? (
							<div className="questions-list">
								{quickQuestionsConfig.map((question, index) => (
									<div
										key={index}
										className="question-item"
										onClick={() => handleQuestionClick(question)}
									>
										<div className="question-icon">{question.icon}</div>
										<div className="question-text">
											<div className="question-title">{question.title}</div>
											{question.description && (
												<div className="question-description">
													{question.description}
												</div>
											)}
										</div>
										<div className="question-arrow">→</div>
									</div>
								))}
							</div>
						) : (
							<div className="question-answer-container">
								<div className="question-header">
									<button
										className="back-button"
										onClick={resetQuestion}
										type="button"
									>
										← {t("back") || "Indietro"}
									</button>
									<div className="selected-question-title">
										{selectedQuestion.title}
									</div>
								</div>

								<Loading visible={loading} />

								{!loading && answer && (
									<div className="answer-content">{renderAnswer()}</div>
								)}
							</div>
						)}
					</div>
				}
			/>
		</div>
	);
}

export default QuickQuestions;
